import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import AddFactorSetDangerousGoodsLineForm from './addFactorSetDangerousGoodsLineForm';
import { FormType } from '../../../../constants/constants';
import { resetDangerousGoodVersionLines, resetFactorSetDangerousGoodLine } from '../../../../reducers/dangerousGoodsLineReducer';

interface IAddFactorSetLineProps {
    classes: any;
    theme: Theme;
    match: any;
    dangerousGoodsLineId?: number;
    factorSetDangerousGoodsId?: number;
    factorSetVersionId?: number;
    resetDangerousGoodsVersionLines: any;
    resetFactorSetDangerousGoodsLine: any;
    type: FormType;
    steps: Array<number>;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetDangerousGoodsVersionLines: () => dispatch(resetDangerousGoodVersionLines()),
    resetFactorSetDangerousGoodsLine: () => dispatch(resetFactorSetDangerousGoodLine())
});

const mapStoreToProps = (store: RootState, ownProps: IAddFactorSetLineProps) => {
    return {
        dangerousGoodsLineId: ownProps.match.params?.dangerousGoodsLineId ? Number(ownProps.match.params?.dangerousGoodsLineId) : undefined,
        factorSetDangerousGoodsId: ownProps.match.params?.dangerousGoodId ? Number(ownProps.match.params?.dangerousGoodId) : undefined,
        factorSetVersionId: ownProps.match.params?.factorSetVersionId ? Number(ownProps.match.params?.factorSetVersionId) : undefined
    };
};

class AddFactorSetDangerousGoodsLine extends Component<IAddFactorSetLineProps> {

    componentWillUnmount() {
        const { resetDangerousGoodsVersionLines, resetFactorSetDangerousGoodsLine } = this.props;

        resetDangerousGoodsVersionLines();
        resetFactorSetDangerousGoodsLine();
    }

    render() {
        const { classes, steps, dangerousGoodsLineId, factorSetDangerousGoodsId, type, factorSetVersionId } = this.props;

        return (
            <div>
                <Card className={classes.root}>
                    <CardContent className={classes.cardContent}>
                        <AddFactorSetDangerousGoodsLineForm dangerousGoodsLineId={dangerousGoodsLineId} factorSetDangerousGoodsId={factorSetDangerousGoodsId} steps={steps} type={type}
                            factorSetVersionId={factorSetVersionId} />
                    </CardContent>
                </Card>
            </div>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddFactorSetDangerousGoodsLine));